<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="1280"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Row :gutter="32">
                <Col :span="6">
                    <Form ref="SearchForms" :model="SearchForms" :rules="SearchRules"  label-position="top">
                        <Row :gutter="32">
                            <Col :span="24">
                                <FormItem label="报销人" prop="apply_id" :rules="[{required: true, type:'number', message: '请选择报销人', trigger: 'change',  transform(value) { return parseInt(value)}}]">
                                    <Select class="search-select" v-model="SearchForms.apply_id"  clearable filterable  placeholder="选择报销人">
                                        <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">{{item.real_name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <Col :span="24">
                                <FormItem label="报销类型" prop="type_id">
                                    <Select class="search-select"   v-model="SearchForms.type_id"  clearable filterable  placeholder="选择类型">
                                        <Option :value="item.type_id" v-for="(item,index) in typeList" :key="index">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <Col :span="24">
                                <FormItem label="报销模式" prop="mode_id">
                                    <Select class="search-select" v-model="SearchForms.mode_id"  clearable filterable  placeholder="选择模式">
                                        <Option :value="1">普通报销</Option>
                                        <Option :value="2">项目报销</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <Col :span="24" v-if="SearchForms.mode_id === 2">
                                <FormItem label="报销项目" prop="project_id">
                                    <Select class="search-select"  v-model="SearchForms.project_id"  clearable filterable  placeholder="选择项目">
                                        <Option :value="item.project_id" v-for="(item,index) in projectList" :key="index">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <Col :span="24">
                                <FormItem label="报销日期" prop="time">
                                    <DatePicker class="width-100" v-model="SearchForms.time" clearable type="daterange" format="yyyy-MM-dd"  placeholder="选择日期" />
                                </FormItem>
                            </Col>
                            <Col :span="24">
                                <Button type="warning" icon="ios-search" @click="SearchSubmit()">查询记录</Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
                <Col :span="18">
                    <Table row-key="id" ref="selection" stripe border :columns="columns" @on-selection-change="tableCheckAll"  :data="dataList" no-data-text="暂无数据记录" height="520">
                        <template #apply_time="{ row }">
                            <div class="d-width text-primary cursor" :title="row.apply_time" @click="showData(row.id)">
                                <span>{{row.apply_time}}</span>
                            </div>
                        </template>
                        <template #mode_id="{ row }">
                            <Tag color="orange" v-if="row.mode_id === 2">项目报销</Tag>
                            <Tag color="blue" v-else>普通报销</Tag>
                        </template>
                        <template #type_id="{ row }">
                            <Tag>{{row.type_name}}</Tag>
                        </template>
                        <template #max_pay_money="{ row }">
                            <div class="d-width" :title="row.max_pay_money?row.max_pay_money:'0.00'">
                                <strong class="text-primary">{{row.max_pay_money?row.max_pay_money:'0.00'}}</strong>
                            </div>
                        </template>
                        <template #project_id="{ row }">
                            <div class="d-width" :title="row.project_name ?? '-'">
                                {{row.project_name ?? '-'}}
                            </div>
                        </template>
                        <template #remark="{ row }">
                            <div class="d-width" :title="row.remark ?? '-'">
                                {{row.remark ?? '-'}}
                            </div>
                        </template>
                    </Table>
                    <div class="em-page">
                        <div class="em-page-btn">
                            <span class="text-999">选中 <em class="text-danger">{{selectCount}}</em> 条记录</span>
                            <Divider type="vertical" />
                            <span class="text-999 mr10">共</span>
                            <strong class="text-orange">{{selectMoney}}</strong>
                            <span class="text-999"> 元</span>
                        </div>
                    </div>
                </Col>
            </Row>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认打款</Button>
            </div>

            <!-- 项目支出详情  -->
            <show-expend-modal v-if="is_show" ref="ShowExpendRef"></show-expend-modal>
        </div>
    </Drawer>
</template>

<script>

import {getExpenseBxList, getExpenseConfig, payAllExpense} from "@/apis/expense";
import ShowExpendModal from "./Show";


export default {
    name: 'AllPay',
    components: {
        ShowExpendModal
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '批量打款',
            isBox : false,
            is_show : false,

            typeList: [],
            userList: [],
            statusList: [],
            projectList: [],
            SearchForms: {
                apply_id: '',
                type_id: '',
                mode_id: '',
                project_id: '',
                time: []
            },
            SearchRules: {},
            dataList : [],
            selectCount  : 0,
            selectMoney  : 0,
            columns: [
                {
                    type: 'selection',
                    width: 55,
                    align: 'center',
                    fixed : 'left'
                },
                {
                    title: '申请日期',
                    key: 'apply_time',
                    slot: 'apply_time',
                    width: 150
                },
                {
                    title: '报销模式',
                    key: 'mode_id',
                    slot: 'mode_id',
                    width: 120,
                },
                {
                    title: '报销类型',
                    key: 'type_id',
                    slot: 'type_id',
                    width: 120,
                },
                {
                    title: '最大报销金额',
                    key: 'max_pay_money',
                    slot: 'max_pay_money',
                    width: 120,
                },
                {
                    title: '申请人',
                    key: 'apply_name',
                    width:100
                },
                {
                    title: '报销项目',
                    key: 'project_id',
                    slot: 'project_id',
                    width: 160,
                },
                {
                    title: '备注',
                    key: 'remark',
                    slot: 'remark'
                }
            ],
        }
    },
    methods: {
        tableCheckAll(){
            let that = this;
            const data = that.$refs.selection.getSelection();
            that.selectCount = data.length;
            var money = 0;
            data.forEach(item => {
                money = money + parseFloat(item.max_pay_money * 100 / 100)
            })
            that.selectMoney = money;
        },
        showData(id){
            let that = this;
            that.is_show = true;
            setTimeout(function(){
                that.$refs.ShowExpendRef.show(id);
            })
        },
        getList(){
            let that = this;
            that.selectMoney = 0;
            that.selectCount = 0;
            const params = {
                search : that.SearchForms
            };
            getExpenseBxList(params).then(e=>{
                that.dataList = e.data;
            })
        },
        getConfig(){
            let that = this;
            getExpenseConfig().then(e=>{
                that.typeList = e.data.typeList ?? [];
                that.userList = e.data.userList ?? [];
                that.statusList = e.data.statusList ?? [];
                that.projectList = e.data.projectList ?? [];
            })
        },

        /**
         功能：
         time: 2025/12/17 10:47
         **/
        show(){
            this.isBox = true;
            this.getConfig();
        },

        SearchSubmit(){
            let that = this;
            this.$refs['SearchForms'].validate((valid) => {
                if (valid) {
                    that.getList();
                }
            })
        },
        /**
         功能：
         time: 2025/12/26 16:14
         **/
        FormSubmit(){
            let that = this;
            const data = that.$refs.selection.getSelection();
            if(data.length <= 0){
                that.$Message.error({ background: true, content:'至少选择一条记录'});
                return false;
            }
            let ids = [];
            for(var i  = 0; i < data.length; i++ ){
                ids.push(data[i].id);
            }
            if(ids.length > 0){
                this.$Modal.confirm({
                    title: '批量打款',
                    content: '此操作将批量打款不可恢复, 是否继续?',
                    onOk: () => {
                        that.$store.commit('SET_LOADING' , true);
                        payAllExpense(ids).then( e =>{
                            that.$Message.success({ background: true,duration:3, content: e.msg });
                            that.FormReset();
                            that.$emit('trueHandler');
                        })
                    },
                    onCancel: () => {}
                });
            }
        },
        /**
         功能：
         time: 2025/12/20 11:54
         **/
        FormReset(){
            this.isBox = false;
            this.title = '报销打款';
            this.$refs['SearchForms'].resetFields();
            this.SearchForms = {
                apply_id: '',
                type_id: '',
                mode_id: '',
                project_id: '',
                time: []
            };
            this.selectCount = 0;
            this.selectMoney = 0;
            this.dataList = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
